import { Component } from "@angular/core";
import { NavController, NavParams, ViewController, Platform, Events, ActionSheetController } from "ionic-angular";
import { IBook } from "../../models/book";

@Component({
  selector: 'page-mybook-detail',
  templateUrl: 'mybook-detail.html',
})
export class MybookDetailPage {

  loading: any;
  book: IBook;
  userid: string;
  isPresent: boolean = false;
  isOpenDetail: boolean = true;

  private callback: Function;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public eventCtrl: Events,
    public platform: Platform,
    public actionSheetCtrl: ActionSheetController,

  ) {
    this.book = navParams.get("book");
    this.userid = navParams.get("iduser");
    this.isPresent = navParams.get("present");
    this.callback = navParams.get('callback');
  }


  // Avvia la lettura del libro
  ReadMyBook() {

    this.navCtrl.pop().then(() => this.callback('readbook:ok', this.book));

  }

  //Rimuove il libro dalla libreria
  RemoveMyBook() {

    let actionSheet = this.actionSheetCtrl.create({
      title: "Rimuovere dalla libreria?",
      buttons: [
        {
          text: "Rimuovi",
          role: "destructive",
          handler: () => {

            console.log("delete clicked");

            this.navCtrl.pop().then(() => this.callback('removebook:ok', this.book));
          }
        },
        {
          text: "Annulla",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        }
      ]
    });
    actionSheet.present();

  }

  toggleSelection() {
    this.isOpenDetail = !this.isOpenDetail;
  }
}



// WEBPACK FOOTER //
// ./src/pages/mybook-detail/mybook-detail.ts